import React from 'react';
import PropTypes from 'prop-types';
import './style.less';
import _ from 'lodash';
import { Button, Checkbox, FormControlLabel, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@material-ui/core';
import { apiBatchRequest } from '../../../utils/api_service';
import { API_URL } from '../../../constants/api';
import { removeNullValuesFromArray } from '../../../utils/helper';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginTop: '5px'
  },
  paper: {
    width: '100%',
    marginBottom: '5px',
    marginTop: '5px'
  },
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  }
}));

// const CheckDuplicate = async (type, name, address, city, state, zipcode, checkOnlyAddress) => {
//   return new Promise(function (resolve, reject) {
//     apiBatchRequest([
//       {
//         url: `${API_URL.Transition.CheckDuplicate}?name=${name}&address=${address}&city=${city}&state=${state}&zipcode=${zipcode}&type=${type}&checkOnlyAddress=${checkOnlyAddress}`,
//         key: 'duplicateRecords'
//       }
//     ])
//       .then(({ duplicateRecords }) => {
//         return resolve(duplicateRecords.data || []);
//       }).catch(() => {
//         return resolve([]);
//       });
//   });
// };

export const CheckboxTable = (props) => {
  const [state, setState] = React.useState(props.value?.split('|') || []);
  const [IsInEditMode, setInEditMode] = React.useState(false);
  const [selectedProperty, setselectedProperty] = React.useState([]);
  const [updateProperty, setUpdatedProperty] = React.useState([]);
  const [isInErrorState, setisInErrorState] = React.useState(false);
  const [reload, setReload] = React.useState(false);
  const classes = useStyles();
  const handleChange = (event, name) => {
    let values = state;
    const selected = selectedProperty;
    const oldValue = values.find(x => (x.split('::')[0])?.toString() === name.toString());
    const value = name + '::' + event.target.name + '::' + oldValue?.split('::')[2] || name;

    values = values.filter(x => (x.split('::')[0])?.toString() !== name.toString());
    if (event.target.checked) {
      if (values.find(x => x === value) === undefined) {
        values.push(value);
      }
    } else {
      // props.onChange && props.onChange(values.join('|'));
    }
    // setselectedProperty(selected);
    values = removeNullValuesFromArray(values);
    setState(values);
    props.onChange && props.onChange(values.join('|'));
  };

  const handleTextChange = (event, name) => {
    let updated = updateProperty;
    const value = event.target.value;
    if (updated.find(x => (x?.id?.toString() !== name.toString()) === undefined)) {
      updated.push({ id: name, value });
    } else {
      updated = updated.filter(x => (x?.id?.toString() !== name.toString()));
      updated.push({ id: name, value });
    }
    setUpdatedProperty(updated);
  };

  const handelEdit = (name) => {
    const selected = selectedProperty;
    if (selected.find(sp => sp === name) === undefined) {
      selected.push(name);
    }

    setselectedProperty(selected);
    setReload(!reload);
  };

  const getButtons = (name, disabled) => {
    if (disabled === false && state.find(op => op?.split('::')?.find(y => y?.toString() === name))) {
      if (selectedProperty.find(sp => sp === name?.toString())) {
        return (<>
          <Button variant="outlined" className="small-text"
            color="primary"
            size="small" onClick={() => {
              let UpdatedProperties = updateProperty;
              const selectedforUpdate = UpdatedProperties.find(up => up.id === name) || {};
              if (selectedforUpdate?.value === undefined || selectedforUpdate?.value === '') {
                (selectedforUpdate || {}).errorMessage = 'New Property name is required';
                (selectedforUpdate || {}).inErrorstate = true;
                setUpdatedProperty(UpdatedProperties);
                setReload(!reload);
                return;
              } else if (state.find(s => s?.split('::')[1] === selectedforUpdate?.value &&
                selectedforUpdate.id?.toString() !== (s?.split('::')[0])?.toString())) {
                (selectedforUpdate || {}).errorMessage = 'New Property name should be unique.';
                (selectedforUpdate || {}).inErrorstate = true;
                setUpdatedProperty(UpdatedProperties);
                setReload(!reload);
                return;
              }
              // const properties = await this.CheckDuplicate('property', selectedforUpdate?.value, '', '', '', '', false);
              // console.log(properties);

              apiBatchRequest([
                {
                  url: `${API_URL.Transition.CheckDuplicate}?name=${selectedforUpdate?.value}&type=${'property'}&checkOnlyAddress=${false}`,
                  key: 'duplicateRecords'
                }
              ])
                .then(({ duplicateRecords }) => {
                  let isvalid = true;
                  if (duplicateRecords.data.length > 0) {
                    duplicateRecords.data?.forEach(element => {
                      if (element.split('::')[1]?.toString() !== name?.toString()) {
                        (selectedforUpdate || {}).errorMessage = 'New Property name should be unique.';
                        (selectedforUpdate || {}).inErrorstate = true;
                        setUpdatedProperty(UpdatedProperties);
                        setReload(!reload);
                        isvalid = false;
                      }
                    });
                  }
                  if (isvalid) {
                    const selected = selectedProperty;
                    setselectedProperty(selected.filter(sp => sp !== name));
                    let values = state;
                    const oldValue = values.find(x => (x.split('::')[0])?.toString() === name.toString());
                    values = values.filter(x => (x.split('::')[0])?.toString() !== name.toString());
                    values.push(name + '::' + UpdatedProperties.find(up => up.id === name)?.value + '::' + oldValue?.split('::')[2] || name);
                    UpdatedProperties = UpdatedProperties.filter(up => up.id !== name);
                    setUpdatedProperty(UpdatedProperties);
                    values = removeNullValuesFromArray(values);
                    setState(values);
                    props.onChange && props.onChange(values.join('|'));
                  }
                }).catch(() => {

                });
            }}>Apply</Button>
          <Button variant="outlined" className="small-text margin-left10" color="primary"
            size="small" onClick={() => {
              const selected = selectedProperty;
              let UpdatedProperties = updateProperty;
              UpdatedProperties = UpdatedProperties.filter(up => up.id !== name);
              setUpdatedProperty(UpdatedProperties);
              setselectedProperty(selected.filter(sp => sp !== name));
              setReload(!reload);
            }}>Cancel</Button></>);
      } else {
        return (<><Button variant="outlined" color="primary"
          size="small" className="small-text" onClick={() => {
            handelEdit(name);
          }}>Edit</Button>
        </>);
      }
    } else {
      return (<></>);
    }
  };

  return (
    <>
      <TableContainer>
        <Table id="checkBoxGridTable"
          className={classes.table}
          aria-labelledby="tableTitle"
          size='small'
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell>Select CIO Property</TableCell>
              <TableCell>Current Property Name</TableCell>
              <TableCell>New Property Name</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {((((props || {}).sourceData || {}).source || []).length === 0 &&
              <TableRow
                key="emptyrow"
                style={{ height: 33 }}
              >
                <TableCell
                  key="emptyrowcell"
                  colSpan={4}
                >
                  No data available
              </TableCell>
              </TableRow>

            )}
            {(((props || {}).sourceData || {}).source || []).map((x, i) =>
            (
              <TableRow key={'tr_' + i}>
                <TableCell>
                  <FormControlLabel
                    key={'checkbox_' + i}
                    value={state.find(op => op?.split('::')?.find(y => y?.toString() === x[props?.sourceData?.optionIdField]?.toString()))}
                    control={
                      <Checkbox
                        id={'cioCheckboxId_' + i}
                        disabled={props.isDisabled}
                        color="primary"
                        checked={state.find(op => op?.split('::')?.find(y => y?.toString() === x[props?.sourceData?.optionIdField]?.toString()))}
                        onChange={(event) => { handleChange(event, x[props?.sourceData?.optionIdField]?.toString()); }}
                        name={x[props?.sourceData?.option]}
                      />
                    }
                    className={'small-text margin-left10'}
                    // label={x[props.sourceData.option]}
                    labelPlacement="end"
                  />
                </TableCell>
                <TableCell>
                  {x[props?.sourceData?.option]}
                </TableCell>
                <TableCell>
                  {state.find(op => op?.split('::')?.find(y => y?.toString() === x[props?.sourceData?.optionIdField]?.toString()))
                    ? selectedProperty.find(sp => sp === x[props?.sourceData?.optionIdField]?.toString())
                      ? <>
                        <TextField
                          error={updateProperty.find(up => up.id === x[props?.sourceData?.optionIdField]?.toString())?.inErrorstate}
                          errorMessage={updateProperty.find(up => up.id === x[props?.sourceData?.optionIdField]?.toString())?.errorMessage}
                          id={
                            'cio_text-field-Id_' + i
                          }
                          key={

                            `text-field-${i}`
                          }
                          onChange={(event) => { handleTextChange(event, x[props?.sourceData?.optionIdField]?.toString()); }}
                          fullWidth
                          value={updateProperty.find(up => up.id === x[props?.sourceData?.optionIdField]?.toString())
                            ? updateProperty.find(up => up.id === x[props?.sourceData?.optionIdField]?.toString()).value
                            : state.find(op => op?.split('::')?.find(y => y?.toString() === x[props?.sourceData?.optionIdField]?.toString()))
                              ? state.find(op => op?.split('::')?.find(y => y?.toString() === x[props?.sourceData?.optionIdField]?.toString())).split('::')[1]
                              : x[props?.sourceData?.option]}
                        />
                        <span className="customError">{updateProperty.find(up => up.id === x[props?.sourceData?.optionIdField]?.toString())?.errorMessage}</span>
                      </>
                      : <>{state.find(op => op?.split('::')?.find(y => y?.toString() === x[props?.sourceData?.optionIdField]?.toString()))
                        ? state.find(op => op?.split('::')?.find(y => y?.toString() === x[props?.sourceData?.optionIdField]?.toString())).split('::')[1]
                        : x[props?.sourceData?.option]}</>
                    : <></>
                  }
                </TableCell>
                <TableCell>{getButtons(x[props?.sourceData?.optionIdField]?.toString(), props.isDisabled)}
                </TableCell>
              </TableRow>
            )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
